module.exports = __webpack_public_path__ + "img/dance.65302a25.png";